'use client';

import { usePathname } from 'next/navigation';

import { pagesMetadata } from '@/.velite';

export function CurrentPageTitle() {
  const pathname = usePathname();

  if (pathname.startsWith('/changelog')) {
    return 'Changelog';
  }

  if (pathname.startsWith('/api-reference')) {
    return 'API Reference';
  }

  const docPage = pagesMetadata.find((docPage) => docPage.pathname === pathname);

  if (!docPage) {
    return null;
  }

  return docPage.title;
}
